import { render, staticRenderFns } from "./GalleriesList.vue?vue&type=template&id=7002d1c3&scoped=true&"
import script from "./GalleriesList.vue?vue&type=script&lang=js&"
export * from "./GalleriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002d1c3",
  null
  
)

export default component.exports